// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CatalogBrandRow-avatarSpacer__ywbhi{flex-shrink:0;width:var(--size-8);height:var(--size-8)}.CatalogBrandRow-menuGuard__dnxPp{display:flex;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatarSpacer": "CatalogBrandRow-avatarSpacer__ywbhi",
	"menuGuard": "CatalogBrandRow-menuGuard__dnxPp"
};
export default ___CSS_LOADER_EXPORT___;
